<section class="events-queue-section">
  <eventq-lined-tab label="Events" [count]="totalCount()" />
  <eventq-data-table
    [columns]="columns"
    [rows]="queueRows()"
    [sort]="sort()"
    [selectedRowId]="selectedRowId()"
    [disabledRowIds]="disabledRowIds()"
    [loading]="queue.isLoading() && !queue.hasValue()"
    [skeletonCount]="5"
    [showLabelWhenEmpty]="true"
    emptyLabel="No events"
    maxHeight="333px"
    (sortChange)="onSort($event)"
    (rowClick)="onRowClick($event)"
  />
</section>
